import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor(private alertController: AlertController) {}

  async showInfo(header: string, message: string, buttonText: string = 'OK') {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: [buttonText],
      cssClass: 'custom-alert info'
    });
    await alert.present();
  }

  async showError(header: string, message: string, buttonText: string = 'Dismiss') {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: [buttonText],
      cssClass: 'custom-alert error'
    });
    await alert.present();
  }

  async showSuccess(header: string, message: string, buttonText: string = 'OK') {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: [buttonText],
      cssClass: 'custom-alert success'
    });
    await alert.present();
  }

  async showConfirm(
    header: string,
    message: string,
    confirmText: string = 'Yes',
    cancelText: string = 'Cancel',
    onConfirm: () => void
  ) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: [
        {
          text: cancelText,
          role: 'cancel'
        },
        {
          text: confirmText,
          cssClass: 'alert-confirm-button',
          handler: () => onConfirm()
        }
      ],
      cssClass: 'custom-alert confirm'
    });
    await alert.present();
  }
}
